import React, { useState } from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";
import { motion } from "framer-motion";

import FieldGroup from "../../FieldGroup/FieldGroup";
import DivideBuy from "../../DivideBuy/DivideBuy";

const Row = styled.div`
    display: flex;
    line-height: 1.5;
    justify-content: space-between;
    text-align: right;

    strong {
        font-weight: 700;
    }
`;

const Top = styled.div`
    margin-top: ${rem(30)};
    padding-bottom: ${rem(10)};
    margin-bottom: ${rem(10)};
`;

const Line = styled.div`
    height: 1px;
    width: 100%;
    background-color: #dbdbdb;
    margin-top: ${rem(30)};
    margin-bottom: ${rem(6)};
`;

const GrandTotal = styled.div`
    padding-top: ${rem(4)};
    border-top: 1px solid #dbdbdb;
    margin-top: ${rem(30)};
    margin-bottom: ${rem(20)};
`;

const ShowDetailsButton = styled.button`
    appearance: none;
    border: 0;
    font-size: 1rem;
    background: none;
    padding: 0;
    cursor: pointer;
    padding-left: ${rem(29)};
    position: relative;
`;

const Circle = styled.div`
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: ${rem(-10)};
    width: ${rem(20)};
    height: ${rem(20)};
    border-radius: 999em;
    background: #ececec;

    &::before,
    &::after {
        content: "";
        position: absolute;
        width: ${rem(10)};
        height: 2px;
        left: ${rem(5)};
        top: 50%;
        margin-top: -1px;
        background: #000;
    }

    &::after {
        transform: rotate(-90deg);
    }

    ${(props) =>
        props.expanded &&
        css`
            &::after {
                display: none;
            }
        `}
`;

const SRP = styled.span`
    font-weight: 700;
    font-size: ${rem(16)};
    line-height: 150%;
    color: #616161;
`;

const ExpandedTable = styled(motion.div)`
    margin-top: ${rem(10)};
    margin-bottom: ${rem(10)};
    overflow: hidden;
`;

const MotionRow = styled(motion.div)`
    display: flex;
    line-height: 1.5;
    justify-content: space-between;

    strong {
        font-weight: 700;
    }
`;

const OldPrice = styled.div`
    font-weight: 700;
    font-size: ${rem(16)};
    line-height: 150%;
    color: #616161;
    text-decoration: line-through;
    text-align: right;
`;

const Bold = styled.span`
    font-weight: 700;
    color: #962d27;
    font-size: ${rem(16)};
`;

const OrderSummary = ({ price, active, details }) => {
    const [isExpanded, expand] = useState(false);
    let nf = new Intl.NumberFormat("en-US");
	const renderTitle = (item, key) => <Row key={key}>
		<span>{item.title}</span>
	</Row> 

    return (
        <FieldGroup title="Order summary">
            <Top>
                <Row>
                    <strong>{details.base.title}</strong>

                    <span>£{details.base.price}</span>
                </Row>
            </Top>

            <ExpandedTable
                animate={isExpanded ? { height: "auto" } : { height: 0 }}
                transition={{ ease: "easeOut", duration: 0.3 }}
            >
                <Row>
                    <strong>Heater</strong>
                </Row>
                {details.heater.map(renderTitle)}
                <Line />
                <Row>
                    <strong>Interior & Exterior</strong>
                </Row>
                {details.InteriorAndExterior.map(renderTitle)}
				<Line />
                {!!active.length && (
					<>
                        <Row>
                            <strong>Accessories</strong>
                        </Row>
                        {active.map((item, key) => {
                            return (
                                <MotionRow
                                    key={key}
                                    animate={isExpanded ? { opacity: 1, x: 0 } : { opacity: 0, x: 10 }}
                                    transition={{
                                        ease: "easeOut",
                                        duration: 0.3,
                                        delay: isExpanded ? 0.2 + 0.1 * 1 : 0,
                                    }}
                                >
                                    <span>{item.label}</span>

                                    <span>£{item.price * item.quantity}</span>
                                </MotionRow>
                            );
                        })}
                    </>
                )}

                <MotionRow
                    animate={isExpanded ? { opacity: 1, x: 0 } : { opacity: 0, x: 10 }}
                    transition={{
                        ease: "easeOut",
                        duration: 0.3,
                        delay: isExpanded ? 0.2 + 0.1 * 1 : 0,
                    }}
                ></MotionRow>
            </ExpandedTable>

            <ShowDetailsButton
                onClick={() => {
                    expand(!isExpanded);
                }}
            >
                {isExpanded ? `Hide` : `Show`} Details
                <Circle expanded={isExpanded} />
            </ShowDetailsButton>

            <GrandTotal>
                <Row>
                    <strong>Total Price</strong>

                    <div>
                        <OldPrice>SRP: £{nf.format(details.base.oldPrice)}</OldPrice>

                        <div style={{ color: "#962d27" }}>
                            NOW <Bold>£{nf.format(price)}</Bold>
                            <span style={{ color: "#962d27" }}></span>
                        </div>
                    </div>
                </Row>
            </GrandTotal>

            <DivideBuy alignRight={true} totalPrice={price} />
        </FieldGroup>
    );
};

export default OrderSummary;
